"use client";

import { quoteThemeColorStyles } from "../quote-theme/quote-theme-css-vars";
import { Calendar } from "lucide-react";
import { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { formatSafeQuoteDate } from "@/components/quotes/helpers/format-safe-date";

export function QuoteBookingConfirmedDepositReminder({
  quote,
  depositAmount,
  depositDueDate,
}: {
  quote: iHolidayQuoteX;
  depositAmount?: number;
  depositDueDate?: number | string;
}) {
  const selectedPaymentDate = formatSafeQuoteDate(
    quote.confirmBookingAction?.paymentDate
  ) || null;

  if (selectedPaymentDate) {
    return (
      <div
        className="p-3 sm:p-4 rounded-xl inline-block"
        style={quoteThemeColorStyles.primary10Bg}
      >
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4" style={quoteThemeColorStyles.primary} />
          <p className="text-sm sm:text-base" style={quoteThemeColorStyles.primary}>
            You selected to pay your deposit on {selectedPaymentDate}
          </p>
        </div>
      </div>
    );
  }

  if (!depositAmount || !depositDueDate) {
    return null;
  }

  return (
    <div
      className="p-3 sm:p-4 rounded-xl inline-block"
      style={quoteThemeColorStyles.primary10Bg}
    >
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4" style={quoteThemeColorStyles.primary} />
        <p className="text-sm sm:text-base" style={quoteThemeColorStyles.primary}>
          Remember: Your deposit of £{depositAmount} is due by{" "}
          {formatSafeQuoteDate(depositDueDate)}
        </p>
      </div>
    </div>
  );
}
